import { rest } from 'msw';

import {
  SERVICE_ID,
  ServiceInfo,
  ServiceInfoResponse,
  STATUS,
  TENDENCY,
} from './index';
import { API_URLS } from '~/configs/api/urls';

const getServiceInfoMock = rest.get(
  `${API_URLS.MEMBER.SERVICE}/:accountKey`,
  async (_, res, ctx) => {
    const response: ServiceInfoResponse = {
      serviceList,
    };

    return res(ctx.json(response));
    // return res(ctx.delay(3000), ctx.json(response));
  }
);

export default getServiceInfoMock;

const serviceList: ServiceInfo[] = [
  {
    serviceId: SERVICE_ID.콘텐츠수신동의,
    serviceName: '콘텐츠 수신 동의',
    status: STATUS.신청가능,
    unableReasonId: '21737',
    unableReasonMessage: '이미 등록된 내역이 존재합니다.',
    registeredDate: '20220622',
    userTendency: TENDENCY.적극투자형,
    serviceTendency: TENDENCY.공격투자형,
    isAllowToSuggestInvestment: true,
  },
];
